export const containerStyles = {
  backgroundColor: 'background.default',
  minHeight: '80vh',
  py: 4,
};

export const paperStyles = {
  p: 4,
  borderRadius: 4,
  background: 'linear-gradient(to bottom, #ffffff 0%, #f8f9fa 100%)',
  boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
};

export const headerContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  mb: 3,
};

export const headerIconStyles = {
  width: 56,
  height: 56,
  borderRadius: 3,
  background: 'linear-gradient(135deg, #3F51B5 0%, #1A237E 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0 4px 12px rgba(63, 81, 181, 0.3)',
};

export const subjectContainerStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1,
  mb: 3,
};

export const textFieldStyles = (hasError = false) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 2,
    '&:hover fieldset': {
      borderColor: hasError ? 'error.main' : 'primary.main',
    },
  },
});

export const contentFieldStyles = {
  mb: 4,
  '& .MuiOutlinedInput-root': {
    borderRadius: 2,
    '&:hover fieldset': {
      borderColor: 'primary.main',
    },
  },
};

export const recipientsSectionStyles = {
  p: 3,
  mb: 3,
  borderRadius: 3,
  backgroundColor: '#f8f9fa',
  border: '2px solid #e9ecef',
};

export const recipientsHeaderStyles = {
  mb: 2,
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const recipientsIconBoxStyles = {
  width: 32,
  height: 32,
  borderRadius: 2,
  backgroundColor: 'secondary.main',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const recipientOptionStyles = (isSelected, isPrimary) => ({
  p: 2,
  borderRadius: 2,
  border: '2px solid',
  borderColor: isSelected 
    ? isPrimary ? 'primary.main' : 'secondary.main' 
    : 'transparent',
  backgroundColor: isSelected 
    ? isPrimary 
      ? 'rgba(63, 81, 181, 0.08)' 
      : 'rgba(26, 35, 126, 0.08)' 
    : '#fff',
  cursor: 'pointer',
  transition: 'all 0.2s',
  '&:hover': {
    borderColor: isPrimary ? 'primary.main' : 'secondary.main',
    transform: 'translateX(4px)',
  },
});

export const tableContainerStyles = {
  width: '100%',
  mb: 2,
};
